import { Typography } from 'antd';
import { Link } from 'react-router-dom';

const shouldHandlePrimaryClick = (event: React.MouseEvent<HTMLElement>) =>
  event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

function TableLink({
  children,
  onClick,
  to,
  title,
  className,
}: {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  to?: string;
  title?: string;
  className?: string;
}) {
  if (to) {
    return (
      <Link
        to={to}
        title={title}
        className={`text-[#1677ff] hover:text-[#69b1ff] hover:underline ${className ?? ''}`}
        onClick={(event) => {
          event.stopPropagation();
          if (shouldHandlePrimaryClick(event) && onClick) {
            // `to` gives the anchor a real href so modified clicks (cmd/ctrl/middle)
            // can open a new tab. For a plain primary click the supplied handler
            // performs the SPA navigation, so prevent the default to stop the Link
            // from ALSO navigating — otherwise the click pushes two history entries
            // and the user has to press Back twice to leave the page.
            event.preventDefault();
            onClick(event);
          }
        }}
      >
        {children}
      </Link>
    );
  }

  return (
    <Typography.Link
      onClick={(event) => {
        event.stopPropagation();
        if (shouldHandlePrimaryClick(event)) {
          onClick?.(event);
        }
      }}
      title={title}
      className={className}
    >
      {children}
    </Typography.Link>
  );
}
export default TableLink;
